<template>
  <div id="addaccessories">
    <div class="row mlr0 mt30 mb30">
      <div class="col-xs-6 prl30">
        <p class="sub-title mb0 mt0 lh25">ACCESSORIES</p>
      </div>
      <div class="col-xs-6 text-right prl30">
        <div class="row lh25">
          <div class="pull-right">
            <span class="font20 black click" @click="$router.go(-1)">✕</span>
          </div>
        </div>
      </div>
    </div>

    <div class="content middle add-accessories" v-loading="loading">
      <div class="cell">
        <div class="container mb50" style="padding-bottom: 50px">
          <div class="row mb10" v-for="(i, index) in accessories"
                  :key="index">
            <div class="col-xs-10 mb10">
              <img style="height:100px" :src="'images/collection/accessories/' + i.SKU_Finished1 + '.png'" />
              <span class="ml20">{{ i.Device_Explanation }}</span>
            </div>
            <div class="col-xs-2">
                <p class="mr10">QTY</p>
                <input
                  type="number"
                  min="0"
                  style="width: 50%"
                  v-model.number="i.quantity"
                />
                <a
                  class="black ml20"
                  @click="resetQuantity(i.SKU_Finished1)"
                >
                  <span class="iconfont3 icon-delete"></span>
                </a>
            </div>
          </div>
          <div class="row mt40">
            <div class="col-xs-offset-3 col-xs-3 text-center">
              <div
                class="click button-select w100"
                @click="confirmQuantites()"
              >
                Confirm Quantites
              </div>
            </div>
            <div class="col-xs-3 text-center">
              <div
                class="click button-select w100"
                @click="$router.go(-1)"
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/project.css";
import axios from "axios";

export default {
  name: "addaccessories",
  data() {
    return {
      accessories: [],
      loading: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData: async function () {
      this.loading = true;
      var roomAccessories = await this.getRoomAccessories();
      axios
        .get("/accessories")
        .then((response) => {
          var accessories = [];
          for(var accessory of response.data) {
            if (roomAccessories.findIndex(acc => accessory.SKU_Finished1 == acc.code) == -1) {
              accessory.quantity = 0;
              accessories.push(accessory)
            }
          }
          this.loading = false;
          this.accessories = accessories;
        })
        .catch(function (error) {
          alert(error);
          this.loading = false;
        });
    },
    async getRoomAccessories() {
      var response = await axios.get("/accessories/room/" + this.$route.params.rid);
      return response.data;
    },
    resetQuantity(id) {
      var accessory = this.accessories.find(item => item.SKU_Finished1 == id);
      accessory.quantity = 0;
    },
    confirmQuantites() {
      var accessoriesToSend = [];

      for (var accessory of this.accessories) {
        if (isNaN(accessory.quantity)) {
          this.$message({
            type: "error",
            message: "Please check entered quantities!",
          });
          return;
        }
        if (accessory.quantity > 0) {
          accessoriesToSend.push({
            quantity : accessory.quantity,
            code: accessory.SKU_Finished1,
            rid: this.$route.params.rid
          })
        }
      }
      
      if (accessoriesToSend.length == 0) {
        return;
      }

      axios
        .post("/accessories/room/" + this.$route.params.rid, {
          accessories: accessoriesToSend,
        })
        .then((res) => {
          if (res.data.result.ok == 1) {
            this.$message({
              type: "success",
              message: "Created!",
            });
            this.$router.push({ path: "/roomtype/" + this.$route.params.rid });
          } else {
            this.$message({
              type: "error",
              message: "Create Failed!",
            });
          }
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
  }
};
</script>

<style>
</style>
